/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PatientProcedureTransactionIntegrationViewModel {
  /**
   * Accession Number linked to Procedure, max length 30
   */
  accessionNumber?: string | null;
  /**
   * Procedure Code
   */
  procedureCode?: string | null;
  /**
   * Attending Provider
   */
  attendingProvider?: string | null;
  /**
   * Referring Provider
   */
  referringProvider?: string | null;
  /**
   * Ordering Provider
   */
  orderingProvider?: string | null;
  /**
   * Primary Provider
   */
  primaryProvider?: string | null;
  /**
   * Supervising Provider
   */
  supervisingProvider?: string | null;
  /**
   * Procedure service from date
   */
  fromDate?: string | null;
  /**
   * Procedure service to date
   */
  toDate?: string | null;
  /**
   * Place of Service Code
   */
  placeOfServiceCode?: string | null;
  /**
   * Location
   */
  location?: string | null;
  /**
   * Modifier 1
   */
  modifier1?: string | null;
  /**
   * Modifier 2
   */
  modifier2?: string | null;
  /**
   * Modifier 3
   */
  modifier3?: string | null;
  /**
   * Modifier 4
   */
  modifier4?: string | null;
  /**
   * Procedure Quantity, defaults to 1 if blank
   */
  quantity?: string | null;
  /**
   * Procedure Authorization, max length 50
   */
  insuranceAuthNumber?: string | null;
  /**
   * NOC Procedure Description, max length 80
   */
  nocProcedureDescription?: string | null;
  /**
   * Prescription Number, max length 100
   */
  prescriptionNumber?: string | null;
  /**
   * Option to hold patient billing
   */
  holdPatientBilling?: boolean | null;
  /**
   * Option to hold Insurance billing
   */
  holdInsuranceBilling?: boolean | null;
  /**
   * Charge Group
   */
  chargeGroup?: number | null;
  /**
   * Claim Comment for this Procedure, max length 80
   */
  claimComment?: string | null;
  /**
   * Diagnosis 1
   */
  diagnosis1?: string | null;
  /**
   * Diagnosis 2
   */
  diagnosis2?: string | null;
  /**
   * Diagnosis 3
   */
  diagnosis3?: string | null;
  /**
   * Diagnosis 4
   */
  diagnosis4?: string | null;
  /**
   * Diagnosis 5
   */
  diagnosis5?: string | null;
  /**
   * Diagnosis 6
   */
  diagnosis6?: string | null;
  /**
   * Diagnosis 7
   */
  diagnosis7?: string | null;
  /**
   * Diagnosis 8
   */
  diagnosis8?: string | null;
  /**
   * Diagnosis 8
   */
  diagnosis9?: string | null;
  /**
   * Diagnosis 10
   */
  diagnosis10?: string | null;
  /**
   * Diagnosis 11
   */
  diagnosis11?: string | null;
  /**
   * Diagnosis 12
   */
  diagnosis12?: string | null;
  /**
   * External Id, max length 50
   */
  externalId?: string | null;
}
